module.exports = __webpack_public_path__ + "static/media/b_king.4886c41f.png";